import React, { useContext, useRef } from 'react';
import '../../../../../../stylesheets/stylesLayout/tableViews.scss';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import { TableBody, TableCell, TableRow } from '@mui/material';
import { cleanedAriId, numColumns } from '../../../ariHelpers';
import { columns } from '../../ariHelpers';
import TableHeader from '../../../TableHeader';
import AriTableRow from './TableRow';
import TablePlaceholder from '../../../TablePlaceholder';
import LinearProgress from '@mui/material/LinearProgress';
import { ContextUserProfile } from '../../../../../../contexts/UserProfileContext';
import { ContextAri } from '../../../../../contextsProperty/ContextAri';

const AriTable = props => {
    const { isLoading, page, order, sort } = useContext(ContextAri);
    const { items } = props;

    const { translate } = useContext(ContextUserProfile);

    const tableContainer = useRef();

    const noResultsText = translate('no_results');

    const tableSize = 'small'; // 'small' | 'medium';

    return (
        <TableContainer
            ref={tableContainer}
            classes={{ root: 'table__container px-1 mt-1' }}
        >
            <Table stickyHeader size={tableSize}>
                <TableHeader
                    columns={columns}
                    order={order}
                    sort={sort}
                    isLoading={isLoading}
                />

                <TableBody>
                    {isLoading && page === 1 ? (
                        <TablePlaceholder
                            rowClassName={`ari--${tableSize}`}
                            numColumns={numColumns}
                        />
                    ) : (
                        items?.map((item, index) => {
                            if (items.length === index + 1) {
                                return (
                                    <AriTableRow
                                        key={cleanedAriId(item.ariId)}
                                        item={item}
                                    />
                                );
                            }
                            return (
                                <AriTableRow
                                    key={cleanedAriId(item.ariId)}
                                    item={item}
                                />
                            );
                        })
                    )}
                    {isLoading && page !== 1 && (
                        <TableRow>
                            <TableCell colSpan={numColumns}>
                                <LinearProgress
                                    classes={{
                                        bar: 'linear-progress__bar',
                                        root: 'linear-progress',
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    )}
                    {items.length === 0 && !isLoading && (
                        <TableRow>
                            <TableCell colSpan={numColumns}>
                                <span
                                    style={{
                                        display: 'inline-block',
                                        width: '100%',
                                        textAlign: 'center',
                                    }}
                                >
                                    {noResultsText}
                                </span>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AriTable;
